const calcSedConcern = (data) => {
    let minCriteria = parseFloat(Math.min(data.criteriaLow, data.criteriaHigh));

    let maxCriteria = parseFloat(Math.max(data.criteriaLow, data.criteriaHigh));

    let minForecast = parseFloat(Math.min(data.forecastLow, data.forecastHigh));
    let maxForecast = parseFloat(Math.max(data.forecastLow, data.forecastHigh));

    if (data.currentValue < minCriteria || data.currentValue > maxCriteria) {
      data.currentConcern = 1;
    } else {
      data.currentConcern = 0;
    }

    if (minForecast < minCriteria || maxForecast > maxCriteria) {
      data.futureConcern = 1;
    } else {
      data.futureConcern = 0;
    }

    if (data.futureConcern) {
      data.attribConcern = 1;
    } else {
      data.attribConcern = 0;
    }
    return data
}

export default calcSedConcern
